import React from 'react';
import LargeButton from '../../../../shared/components/LargeButton';
import cx from 'classnames';

/**
 * @typedef {object} OrganizationInfoCardProps
 * @property {(id: number) => void} onClick
 * @property {Object} org
 */

/**
 * @param {OrganizationInfoCardProps} props
 */
const OrganizationInfoCard = props => {
  const { org, onClick } = props;

  return (
    <div key={org.Id} className='item-search__results-row'>
      <LargeButton onClick={() => onClick(org.Id)} className={cx({ inactive: !org.IsActive })}>
        <div className='button__sections'>
          <div className='button__section-column'>
            <div className='button__org-unit'>{org.Name}</div>
            {org.PaidAssigned !== undefined && (
              <div>
                Paid Org licenses: {org.PaidAssigned} of {org.PaidTotal}
              </div>
            )}
          </div>
          <div className='button__section-column'>
            <div>Units: {org.OrgUnitCount}</div>
            {org.OrgUnitsPaidAssigned !== undefined && (
              <div>
                Paid Unit licenses: {org.OrgUnitsPaidAssigned} of {org.OrgUnitsPaidTotal}
              </div>
            )}
          </div>
          <div className='button__section-column'>{!org.IsActive && <div>De-Enrolled</div>}</div>
        </div>
      </LargeButton>
    </div>
  );
};

export default OrganizationInfoCard;
